import { render } from "./attendeeform.vue?vue&type=template&id=81e73d6c&scoped=true"
import script from "./attendeeform.vue?vue&type=script&lang=js"
export * from "./attendeeform.vue?vue&type=script&lang=js"

import "./attendeeform.vue?vue&type=style&index=0&id=81e73d6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-81e73d6c"

export default script